import React, { useState } from "react";
import { TextField, Button, Typography, Box } from "@mui/material";

const ChatForm = ({ onSubmit, webDetail }) => {
  const [userInfo, setUserInfo] = useState({ name: "", email: "" });
  const [errors, setErrors] = useState({ name: "", email: "" });
  const [isSubmitted, setIsSubmitted] = useState(false);

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  console.log("ChatForm webDetail---->", webDetail);

  const validateFields = (field, value) => {
    let error = "";
    if (field === "name") {
      if (!value.trim()) error = "Name is required.";
      else if (value.length < 3) error = "Name must be at least 3 characters.";
    } else if (field === "email") {
      if (!value.trim()) error = "Email is required.";
      else if (!validateEmail(value)) error = "Enter a valid email address.";
    }
    return error;
  };

  const handleBlur = (field) => {
    setErrors((prev) => ({
      ...prev,
      [field]: validateFields(field, userInfo[field]),
    }));
  };

  const handleChange = (e) => {
    setUserInfo({ ...userInfo, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitted(true);

    const newErrors = {
      name: validateFields("name", userInfo.name),
      email: validateFields("email", userInfo.email),
    };

    setErrors(newErrors);

    if (!newErrors.name && !newErrors.email) {
      onSubmit(userInfo);
    }
  };

  return (
    <>
      <Box className="user-info-form-container">
        <Typography variant="h6" className="user-info-form-title">
          Let's Get Started
        </Typography>
        <Typography variant="body2" className="user-info-form-description">
          Please provide your name and email so we can follow up with you.
        </Typography>
        <form onSubmit={handleSubmit} className="user-info-form" noValidate>
          <TextField
            label="Your Name"
            fullWidth
            name="name"
            value={userInfo.name}
            onChange={handleChange}
            onBlur={() => handleBlur("name")}
            margin="dense"
            error={isSubmitted && !!errors.name}
            helperText={isSubmitted && errors.name}
          />
          <TextField
            label="Your Email"
            fullWidth
            name="email"
            type="email"
            value={userInfo.email}
            onChange={handleChange}
            onBlur={() => handleBlur("email")}
            margin="dense"
            error={isSubmitted && !!errors.email}
            helperText={isSubmitted && errors.email}
          />

          <Button type="submit" variant="contained" color="primary" fullWidth>
            Start Chat
          </Button>
        </form>
      </Box>
    </>
  );
};

export default ChatForm;
